// extracted by mini-css-extract-plugin
export default {"title":"pilih-tipe-listing_title__g8c4u"};